import _ from 'lodash'

const toBoolean = (value) => {
  if (typeof value === 'string') {
    return ['1', 'true', 'sim', 'yes'].includes(value.trim().toLowerCase())
  }

  return value === true || value === 1
}

const getDirectRestrictionFlag = (user, flag) => {
  const camelFlag = flag.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
  const candidates = [
    _.get(user, flag),
    _.get(user, camelFlag),
    _.get(user, `data.${flag}`),
    _.get(user, `data.${camelFlag}`),
    _.get(user, `custom_role.${flag}`),
    _.get(user, `custom_role.${camelFlag}`),
    _.get(user, `custom_role.data.${flag}`),
    _.get(user, `custom_role.data.${camelFlag}`),
    _.get(user, `customRole.${flag}`),
    _.get(user, `customRole.${camelFlag}`),
    _.get(user, `customRole.data.${flag}`),
    _.get(user, `customRole.data.${camelFlag}`),
    _.get(user, `role.${flag}`),
    _.get(user, `role.${camelFlag}`),
    _.get(user, `role.data.${flag}`),
    _.get(user, `role.data.${camelFlag}`),
    _.get(user, `custom_permissions.acessos_gerais.${flag}`),
    _.get(user, `custom_permissions.acessos_gerais.${camelFlag}`),
    _.get(user, `custom_permissions.acessosGerais.${flag}`),
    _.get(user, `custom_permissions.acessosGerais.${camelFlag}`)
  ]

  const definedValue = _.find(candidates, (value) => typeof value !== 'undefined' && value !== null)
  if (typeof definedValue === 'undefined') {
    return null
  }

  return toBoolean(definedValue)
}

export const getUserRestrictionFlag = (user, flag) => {
  if (!user) return false

  const directValue = getDirectRestrictionFlag(user, flag)
  if (directValue !== null) {
    return directValue
  }
  return false
}

export const primeUserRestrictions = () => Promise.resolve(null)



// WEBPACK FOOTER //
// ./src/utils/roleRestrictions.js